import { lazy } from 'react';
import type { AppModuleManifest } from '../types';

const manifest: AppModuleManifest = {
  slug: 'disposition',
  name: 'Auswertungen',
  icon: 'BarChart3',
  persistent: false,
  routes: [
    // Default: Modul-Root leitet auf Auswertungen-Uebersicht
    { path: '/',                component: lazy(() => import('./pages/Index')),              navigation: 'hidden' },

    // Sidebar-Eintrag
    { path: '/auswertungen',    component: lazy(() => import('./pages/AuswertungenPage')),   label: 'Übersicht',  navigation: 'main', permission: 'reports.read_all' },

    // Auswertungs-Detail-Seiten — per URL erreichbar, nicht in Sidebar
    { path: '/aufgaben',        component: lazy(() => import('./pages/AufgabenPage')),       navigation: 'hidden', permission: 'reports.read_all' },
    { path: '/mitarbeiter',     component: lazy(() => import('./pages/MitarbeiterPage')),    navigation: 'hidden', permission: 'reports.read_all' },
    { path: '/kunden',          component: lazy(() => import('./pages/KundenPage')),         navigation: 'hidden', permission: 'reports.read_all' },
    { path: '/materialien',     component: lazy(() => import('./pages/MaterialienPage')),    navigation: 'hidden', permission: 'reports.read_all' },
  ],
  roles: ['user', 'admin'],
};

export default manifest;
